<template>
  <div>
    <v-flex id="diagnosisList" xs12>
      <OrthopedicDiagnosisList
        :value="value"
        :typeOfSurgery="typeOfSurgery"
        :anatomicRegion="anatomicRegion"
        @input="decompressDiagnosis($event)"
        name="Diagnósticos"
        :singleSelect="true"
        singularName="Diagnóstico"
      />
    </v-flex>
    <v-flex xs12>
      <HintField
        v-if="hasOtherDiagnosis"
        componentId="orthopedic-diagnosis-other"
        label="Diagnóstico (texto livre)"
        :value="orthopedicDiagnosisOther"
        @input="$emit('update:orthopedicDiagnosisOther', $event)"
      />
    </v-flex>
  </div>
</template>
<script>
import { TraumaDiagnosis, OrthopedicDiagnosis } from '@/models/Orthopedics'
import HintField from './HintField'
import OrthopedicDiagnosisList from './OrthopedicDiagnosisList'

export default {
  components: { OrthopedicDiagnosisList, HintField },
  props: {
    value: { type: Array, default: () => [] },
    orthopedicDiagnosisOther: { type: String },
    typeOfSurgery: { type: String },
    anatomicRegion: { type: String },
    orthopedicDiagnosisId: { type: String }
  },
  data() {
    return {}
  },
  computed: {
    hasOtherDiagnosis() {
      return this.value.some(d => d.id === 'other')
    }
  },
  methods: {
    decompressDiagnosis(diagnostics) {
      document.getElementById('diagnosisList').scrollIntoView(false)
      let diagnosisId =
        diagnostics && diagnostics.length ? diagnostics[0].id : null
      let anatomicRegionId = this.getRegionIdByDiagnosisId(diagnosisId)

      this.$emit('input', diagnostics)
      this.$emit('update:diagnosis-id', diagnosisId)
      this.$emit('update:anatomic-region-id', anatomicRegionId)
    },
    getRegionIdByDiagnosisId(id) {
      if (id) {
        let item = TraumaDiagnosis.query()
          .with('region')
          .find(id)
        item = item
          ? item
          : OrthopedicDiagnosis.query()
              .with('region')
              .find(id)
        return item.region.id
      } else {
        return null
      }
    }
  }
}
</script>
